import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import CheckVacationTable from "./table/CheckVacationTable.vue";
import CheckApprovalTable from "./table/CheckAttendanceTable.vue";
import CheckOverworkTable from "./table/CheckOverworkTable.vue";
import CheckShiftTable from "./table/CheckShiftTable.vue";

type Props = {
  value?: number;
};

type Emits = {
  (e: "update:modelValue", value: number): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckApprovalView',
  props: {
    value: { default: 0 }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "update:modelValue", value: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: number };




const modelValue = computed({
  get: () => props.value,
  set: (newValue: number) => emits("update:modelValue", newValue)
});

const tabItems = [
  { text: "休暇", component: CheckVacationTable },
  { text: "シフト", component: CheckShiftTable },
  { text: "残業", component: CheckOverworkTable },
  { text: "勤務時間変更", component: CheckApprovalTable }
] as const;

return { __sfc: true,props, emits, modelValue, tabItems }
}

})